<template>
  <v-dialog v-model="isOpen" class="confirm-modal-dialog">
    <v-card class="modal-card">
      <v-card-title class="modal-title">
        <h2 class="modal-title-text">Confirm changes</h2>
        <v-icon @click="handleClose">mdi-close</v-icon>
      </v-card-title>
      <div class="modal-divider-wrapper">
        <span class="modal-divider"></span>
      </div>

      <v-card-text>
        <div class="modal-content-center">
          <img src="/images/doc-slide-dec.svg" alt="" />
          <h1 class="modal-heading">Attach Google Slides?</h1>
          <p class="modal-description">
            This slide deck will overwrite the current one. Are you sure want to
            change it?.
          </p>
        </div>

        <div class="confirm-buttons-wrapper">
          <button class="btn-cancel-outline" @click="handleCancel">
            Cancel
          </button>
          <button class="btn-confirm-outline" @click="handleConfirm">
            Confirm
          </button>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "confirm", "cancel", "close"]);

const isOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const handleClose = () => {
  isOpen.value = false;
  emit("close");
};

const handleCancel = () => {
  emit("cancel");
  isOpen.value = false;
};

const handleConfirm = () => {
  emit("confirm");
};
</script>

<style scoped>
.confirm-modal-dialog {
  width: 800px;
}

.modal-card {
  border-radius: 16px;
}

.modal-title {
  display: flex;
  justify-content: space-between;
}

.modal-title-text {
  color: var(--primary-blue);
  font-size: var(--fs-big);
  font-weight: 600;
}

.modal-divider-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}

.modal-divider {
  width: 94%;
  border: solid 1px #f2f3fc;
}

.modal-content-center {
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}

.modal-heading {
  color: var(--primary-blue);
  font-size: 32px;
  font-weight: 600;
}

.modal-description {
  font-size: var(--fs-big);
  font-weight: 400;
}

.confirm-buttons-wrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.btn-cancel-outline {
  width: 48%;
  border: 1px solid #e00069;
  color: #e00069;
  padding: 10px;
  border-radius: 16px;
  background-color: transparent;
  cursor: pointer;
}

.btn-confirm-outline {
  background-color: var(--primary-blue);
  color: white;
  width: 48%;
  padding: 10px;
  border-radius: 16px;
  border: none;
  cursor: pointer;
}
</style>
